import { useMutation } from "@tanstack/react-query";

import type { QuoteImportApi } from "../../../api";
import type {
	ImportedQuoteAnalyzeResponse,
	ImportedQuoteTable,
} from "../../../types/imported-quote-table.type";

/**
 * Analyze mutation — POSTs a workbook to the provided import api and returns the
 * editable preview IR. Server-state/async lifecycle is owned by React Query
 * (loading/error) rather than bespoke `useState`/try-catch (AC4).
 */
export const useAnalyzeSpreadsheet = (api: QuoteImportApi) =>
	useMutation<ImportedQuoteAnalyzeResponse, unknown, File>({
		mutationFn: (file: File) => api.analyze(file),
	});

/** Apply mutation — persists the confirmed tables via the provided import api. */
export const useApplyQuoteImport = (api: QuoteImportApi) =>
	useMutation<void, unknown, ImportedQuoteTable[]>({
		mutationFn: (tables: ImportedQuoteTable[]) => api.apply(tables),
	});
